var exports = {
  "e6": "TransferOwnershipModal.module__warningBox___allVeH",
  "i4": "TransferOwnershipModal.module__warningText___allVeH",
};

module.exports = exports;
